export default __webpack_public_path__ + "static/media/4-grinning-face-with-one-large-and-one-small-eye_1f92a.0a3f728d.png";